import { Component, inject } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgbDropdown, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { selectCurrentLocation } from '../../../stores/locations/locations.selector';
import { selectCurrentRoom } from '../../../stores/rooms/rooms.selector';
import { LocationDeleteModalComponent } from '../location-delete-modal/location-delete-modal.component';
import { RoomDeleteModalComponent } from '../room-delete-modal/room-delete-modal.component';

@Component({
  selector: 'era-delete-actions',
  templateUrl: './delete-actions.container.html',
  imports: [NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownItem, FaIconComponent],
})
export class DeleteActionsContainerComponent {
  private readonly store = inject(Store);
  private readonly modalService = inject(NgbModal);

  public readonly room = this.store.selectSignal(selectCurrentRoom);
  public readonly location = this.store.selectSignal(selectCurrentLocation);

  public openDeleteLocationModal(): void {
    this.modalService.open(LocationDeleteModalComponent);
  }

  public openDeleteRoomModal(): void {
    this.modalService.open(RoomDeleteModalComponent);
  }
}
